import React, { useContext, useEffect } from "react";
import { useState } from "react";

import { MenuItem, Select, TableFooter, TextField, Typography } from "@mui/material";
import { TablePagination } from "@mui/material";
import { Paper, Stack, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { IOperacoesCulturais } from "../../../Interfaces/cadernos/caderno5/interfaces5C";
import { operacaocultural, tipoFertilizacao } from "../../../informacao_estatica";
import { useLocation } from "react-router-dom";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";


interface IExtraProps {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  set_especie_ou_lote_homegenio_selecionada: React.Dispatch<React.SetStateAction<IZonaHomogenea | undefined>>;
  especie_ou_lote_homegenio_lista: IZonaHomogenea[] | undefined;
  especie_ou_lote_homegenio_selecionada: IZonaHomogenea | undefined;
  rows: IOperacoesCulturais[];
  setRows: React.Dispatch<React.SetStateAction<IOperacoesCulturais[]>>;
  rows_filtrada: IOperacoesCulturais[];
  setRows_filtrada: React.Dispatch<React.SetStateAction<IOperacoesCulturais[]>>;
}


export const OperacoesCulturaisForm: React.FC<IExtraProps> = ({
  set_especie_ou_lote_homegenio_selecionada,
  especie_ou_lote_homegenio_lista,
  especie_ou_lote_homegenio_selecionada,
  isLoading,
  setIsLoading,
  setMessage,
  setOpenSnackError,
  setOpenSnackSuccess,
  rows,
  setRows,
  rows_filtrada,
  setRows_filtrada,

}) => {
  const location = useLocation();
  const auth = useContext(AuthContext);
  const is_historico = location.state?.is_historico ?? false;

  const [showNewRow, setShowNewRow] = useState(false);

  const [openDelete, setOpenDelete] = React.useState(false);
  const message_apenas_numero = ("Apenas números são aceites");
  const [error_data, set_error_data] = useState<boolean>(false);
  const [error_t, set_error_t] = useState<boolean>(false);
  const [error_m, set_error_m] = useState<boolean>(false);
  const [error_n, set_error_n] = useState<boolean>(false);
  const [error_po, set_error_po] = useState<boolean>(false);
  const [error_ko, set_error_ko] = useState<boolean>(false);
  const [error_mgo, set_error_mgo] = useState<boolean>(false);
  const [error_cao, set_error_cao] = useState<boolean>(false);
  const [error_so, set_error_so] = useState<boolean>(false);
  const [error_b, set_error_b] = useState<boolean>(false);

  const [operacoes, setOperacoes] = useState<IOperacoesCulturais>();

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    set_error_data(false)
    set_error_t(false)
    set_error_m(false)
    set_error_n(false)
    set_error_po(false)
    set_error_ko(false)
    set_error_mgo(false)
    set_error_cao(false)
    set_error_so(false)
    set_error_b(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    setOperacoes(undefined)
    setShowNewRow(false)


  };

  async function getOperacoesCulturais() {

    try {
      let res = await get(auth.token.cookie_token, `/get_reg_oper_culturais_PP_um_5c_rosto/${location.state.id_rosto}`);

      if (res.status === 200) {
        setRows(res.data.result);
        setRows_filtrada(res.data.result);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getOperacoesCulturais", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }



  useEffect(() => {
    (async () => {
      await getOperacoesCulturais();
    })();
  }, []);

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    if (name === "data") {
      if (value === undefined || value === "") {
        set_error_data(true);
      } else {
        set_error_data(false);
      }

      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    } else if (name === "t") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_t(true);

      } else {
        set_error_t(false);
      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "m") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_m(true);
      } else {
        set_error_m(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "n") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_n(true);
      } else {
        set_error_n(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "po") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_po(true);
      } else {
        set_error_po(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "ko") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ko(true);
      } else {
        set_error_ko(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "mgo") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_mgo(true);
      } else {
        set_error_mgo(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "cao") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_cao(true);
      } else {
        set_error_cao(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "so") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_so(true);
      } else {
        set_error_so(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === "b") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_b(true);
      } else {
        set_error_b(false);

      }
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else {
      setOperacoes((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    }

  };

  const handleSave = async () => {
    if (operacoes?.data === undefined || operacoes?.data === "") {
      set_error_data(true);
      setMessage("Preencha a data!");
      setOpenSnackError(true);
      return;
    }
    if (operacoes === undefined) {
      setMessage("Preencha os campos obrigatórios!");
      setOpenSnackError(true);
    } else {

      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "new_reg_oper_culturais_PP_um_5c", {
          payload: {
            id_regis_ope_cult: 0,
            zona_homo: operacoes?.zona_homo === undefined ? null : operacoes.zona_homo,
            area: operacoes?.area === undefined ? 0 : operacoes.area,
            data: operacoes?.data === undefined ? null : operacoes?.data,
            especis_exis: operacoes?.especis_exis === undefined ? null : operacoes.especis_exis,
            oper_cultural: operacoes?.oper_cultural === undefined ? null : operacoes.oper_cultural,
            tipo_ferti: operacoes?.tipo_ferti === undefined ? null : operacoes.tipo_ferti,
            ferti_utilizado: operacoes?.ferti_utilizado === undefined ? null : operacoes.ferti_utilizado,
            t: operacoes?.t === undefined ? null : operacoes?.t,
            m: operacoes?.m === undefined ? null : operacoes.m,
            n: operacoes?.n === undefined ? null : operacoes.n,
            po: operacoes?.po === undefined ? null : operacoes.po,
            ko: operacoes?.ko === undefined ? null : operacoes.ko,
            mgo: operacoes?.mgo === undefined ? null : operacoes?.mgo,
            cao: operacoes?.cao === undefined ? null : operacoes.cao,
            so: operacoes?.so === undefined ? null : operacoes.so,
            b: operacoes?.b === undefined ? null : operacoes?.b,
            opcao: operacoes?.opcao === undefined ? null : operacoes.opcao,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");

          setOperacoes(undefined);
          setRows((prevRows) => {
            return [...prevRows, res.data.result];
          });
          setRows_filtrada((prevRows) => {
            return [...prevRows, res.data.result];
          });
          setOpenSnackSuccess(true);
          setShowNewRow(false);
          set_error_data(false)
          set_error_t(false)
          set_error_m(false)
          set_error_n(false)
          set_error_po(false)
          set_error_ko(false)
          set_error_mgo(false)
          set_error_cao(false)
          set_error_so(false)
          set_error_b(false)
          set_flag_editado(false)
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveNOperCulturais", error, true);
        if ((error as any)?.response?.data?.message) {
          setMessage((error as any).response.data.message);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
        }
        setOpenSnackError(true);
        setIsLoading(false);
      }
    }
  };

  // EDITAR
  const handleEdit = (obj: IOperacoesCulturais) => {
    setOperacoes(obj);
    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista?.find((el: IZonaHomogenea) => el.zona_homogenea === obj.zona_homo)

    if (aux_obj_zona_homogenea_selecionada !== undefined) {
      set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    }
  };



  const handleUpdate = async () => {
    if (operacoes?.data === undefined || operacoes?.data === "") {
      set_error_data(true);
      setMessage("Preencha a data!");
      setOpenSnackError(true);
      return;
    } else {
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, `update_reg_oper_culturais_PP_um_5c`, {
          payload: {

            id_regis_ope_cult: operacoes.id_regis_ope_cult,
            zona_homo: operacoes?.zona_homo === undefined ? null : operacoes.zona_homo,
            area: operacoes?.area === undefined ? 0 : operacoes.area,
            data: operacoes?.data === undefined ? null : operacoes?.data,
            especis_exis: operacoes?.especis_exis === undefined ? null : operacoes.especis_exis,
            oper_cultural: operacoes?.oper_cultural === undefined ? null : operacoes.oper_cultural,
            tipo_ferti: operacoes?.tipo_ferti === undefined ? null : operacoes.tipo_ferti,
            ferti_utilizado: operacoes?.ferti_utilizado === undefined ? null : operacoes.ferti_utilizado,
            t: operacoes?.t === undefined ? null : operacoes?.t,
            m: operacoes?.m === undefined ? null : operacoes.m,
            n: operacoes?.n === undefined ? null : operacoes.n,
            po: operacoes?.po === undefined ? null : operacoes.po,
            ko: operacoes?.ko === undefined ? null : operacoes.ko,
            mgo: operacoes?.mgo === undefined ? null : operacoes?.mgo,
            cao: operacoes?.cao === undefined ? null : operacoes.cao,
            so: operacoes?.so === undefined ? null : operacoes.so,
            b: operacoes?.b === undefined ? null : operacoes?.b,
            opcao: operacoes?.opcao === undefined ? null : operacoes.opcao,
            id_rosto: location.state.id_rosto,
            last_update: operacoes?.last_update === undefined ? null : operacoes.last_update,
            create_date: operacoes?.create_date === undefined ? null : operacoes.create_date,
            uuid: operacoes?.uuid === undefined ? null : operacoes.uuid,

          }
        });

        if (res.status === 200) {
          setMessage("Registado com sucesso!");
          const updatedRows = rows.map((row) => {
            if (row.id_regis_ope_cult === operacoes.id_regis_ope_cult) {
              return res.data.result
            } else {
              return { ...row }
            }
          });

          setRows(updatedRows !== undefined ? updatedRows : []);
          setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
          setOperacoes(undefined);
          setOpenSnackSuccess(true);
          set_error_data(false)
          set_error_t(false)
          set_error_m(false)
          set_error_n(false)
          set_error_po(false)
          set_error_ko(false)
          set_error_mgo(false)
          set_error_cao(false)
          set_error_so(false)
          set_error_b(false)
          set_flag_editado(false)
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveEdit", error, true);
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
        setIsLoading(false);
      }


    }
  };

  // Delete
  const handleClickOpenDelete = (obj: IOperacoesCulturais) => {
    setOperacoes(obj)
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `delete__reg_oper_culturais_PP_um_5c/${operacoes?.id_regis_ope_cult}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDelete(false);
        setOperacoes(undefined);

        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_regis_ope_cult !== operacoes?.id_regis_ope_cult),
        ]);
        setRows_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_regis_ope_cult !== operacoes?.id_regis_ope_cult),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /*****************  PAGINAÇÃO ********************** */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows_filtrada.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {

    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista?.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    if (aux_obj_zona_homogenea_selecionada !== undefined) {
      set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
      setOperacoes((prevOperacoes: any) => ({
        ...prevOperacoes,
        area: aux_obj_zona_homogenea_selecionada?.area,
        zona_homo: aux_obj_zona_homogenea_selecionada?.zona_homogenea,
      }));
    }


  }

  return (
    <CustomThemeProvider>
      {isLoading ?
        <LoadingVulpes /> :
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ height: "auto", width: "auto", margin: 2, padding: 2, }}
        >

          <table style={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={18}
                  sx={{ fontWeight: 700, fontSize: 18, fontFamily: "candara", }}>
                  <Stack direction="row" justifyContent="start" alignItems="center">
                    5C - Registo das Atividades pastagens permanentes e pastagens
                    biodiversas
                    <BasicPopover text={"Registo obrigatório para as seguintes intervenções: Maneio da Pastagem Permanente e Conservação do solo-Pastagens Biodiversas. \n\n Pretende-se que o beneficiário registe qualquer intervenção nas pastagens permanentes,\n nomeadamente as datas da instalação (quando a pastagem permanente é instalada no a que respeita o registo), ressementeiras,\n controlo da vegetação arbustiva, rotação do pastoreio e a aplicação de fertilizantes, com base nos resultados dos boletins de análise e nas produções obtidas."} />
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={16}
                  sx={{ fontWeight: 600, fontFamily: "candara", fontSize: 17 }}
                > 1 - Registo das operações culturais </TableCell>
                <TableCell colSpan={2}>
                  {is_historico === true ? <></> :

                    <BarraDeFerramentas
                      mostrarBotaoNovo
                      textoBotaoNovo="Novo Registo"
                      aoClicarNovo={() => {
                        setOperacoes(undefined);
                        setShowNewRow(true)
                        setOperacoes((prevOperacoes: any) => ({
                          ...prevOperacoes,
                          area: especie_ou_lote_homegenio_selecionada?.area,
                          zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea,
                        }));
                      }}
                    />}
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead rowSpan={2}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Zona Homogénea*
                    <BasicPopover text={" O registo das atividades deverá ser efetuado de acordo com\n a zona homogénea indicada no separador \n«caracterização das áreas sob compromisso»."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Área (ha)*
                    <BasicPopover text={"Área da zona homogénea corresponde ao somatório das subparcelas que a compõem"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ minWidth: 100 }}>Data*</StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Especies existentes no coberto vegetal
                    <BasicPopover text={"Identificar as diferentes espécies ou géneros de plantas\n presentes na zona homogénea, incluindo das leguminosas, quando presentes. \n\nRegisto das espécies/géneros deve ser feito utilizando ';' a separar as\n diferentes espécies presentes na pastagem. (exemplo: azevém; tremocilha; ...)"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} >
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Operação Cultural
                    <BasicPopover text={"Registar a operação efetuada em determinada data: \nSementeira \nRessementeira \nControlo vegetação arbustiva"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2}>
                  <Stack direction="row" justifyContent="center" alignItems="center" >
                    Tipo de fertilização
                    <BasicPopover text={"O beneficiário deverá preencher com um dos seguintes valores por linha (data da aplicação):\nAplicação de corretivos\nFertilização fundo\nAplicação de estrume\nAplicação de chorume\nFertilização cobertura\nFertirrega"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}>
                  Fertilizante utilizado
                </StyledTableHead>
                <StyledTableHead colSpan={2}>Quantidade Aplicada</StyledTableHead>
                <StyledTableHead colSpan={8}>
                  Aplicação de nutrientes (kg/ha)
                </StyledTableHead>
                <StyledTableHead rowSpan={2}>Ações</StyledTableHead>
              </TableRow>

              <TableRow>
                <StyledTableHead sx={{ minWidth: 80 }}>t/ha</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>m3/ha</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>
                  <Stack direction="row" justifyContent="center" alignItems="center"  >
                    N
                    <BasicPopover
                      text={"Ter em atenção que na intervenção «conservação do solo-pastagens\n biodiversas» não é permitida a aplicação de azoto após a instalação da pastagem."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>P2O5</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>K2O</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>MgO</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>CaO</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>SO3</StyledTableHead>
                <StyledTableHead sx={{ minWidth: 80 }}>B</StyledTableHead>
                <StyledTableHead width={150}>Outros<BasicPopover text={"Identificar o nutriente aplicado, quando este não esteja representado no registo"} /></StyledTableHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {showNewRow && (
                <TableRow>
                  <StyledTableCell>
                    {especie_ou_lote_homegenio_lista !== undefined ? (
                      <>
                        <Select
                          value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                          label={''}
                          name={'zona_homogenea'}
                          // defaultValue={especie_ou_lote_homegenio_selecionada?.id_cara === undefined ? 0 : especie_ou_lote_homegenio_selecionada?.id_cara}
                          sx={{
                            fontSize: 14,
                            fontFamily: "verdana",
                            minWidth: 200,
                          }}
                          onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                        >

                          {especie_ou_lote_homegenio_lista.map((item: IZonaHomogenea, key) => {

                            return (
                              <MenuItem key={key} value={item.zona_homogenea}>
                                <Typography
                                  style={{
                                    fontSize: 14,
                                    fontFamily: "candara",
                                  }}
                                >
                                  {item.zona_homogenea}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </>
                    ) : (
                      <></>
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    {especie_ou_lote_homegenio_selecionada?.area !== undefined ? formatarNumero_recebido_com_casa_decimais(especie_ou_lote_homegenio_selecionada?.area) : '0,00'}

                  </StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      variant="filled"
                      type="date"
                      name="data"
                      value={operacoes?.data === undefined ? "" : operacoes.data}
                      onChange={onInputChange}
                    />
                    {error_data && (
                      <p style={{ color: "#c90606", fontSize: "11px" }}>
                        Preencha este campo
                      </p>
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="especis_exis"
                      value={operacoes?.especis_exis === undefined ? "" : operacoes.especis_exis}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomSelect
                      value={operacoes?.oper_cultural !== undefined ? operacoes?.oper_cultural : ""}
                      name="oper_cultural"
                      onChange={onInputChange}
                      options={operacaocultural}
                      label="Fertilização"
                      minWidth={120}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomSelect
                      value={operacoes?.tipo_ferti === undefined ? "" : operacoes?.tipo_ferti}
                      name="tipo_ferti"
                      onChange={onInputChange}
                      options={tipoFertilizacao}
                      label="Tipo de fertilizante"
                      minWidth={120}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="ferti_utilizado"
                      value={operacoes?.ferti_utilizado === undefined ? "" : operacoes.ferti_utilizado}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="t"
                      value={operacoes?.t === undefined ? "" : operacoes.t}
                      onChange={onInputChange}
                      error={error_t}
                      helperText={error_t ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="m"
                      value={operacoes?.m === undefined ? "" : operacoes.m}
                      onChange={onInputChange}
                      error={error_m}
                      helperText={error_m ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="n"
                      value={operacoes?.n === undefined ? "" : operacoes.n}
                      onChange={onInputChange}
                      error={error_n}
                      helperText={error_n ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="po"
                      value={operacoes?.po === undefined ? "" : operacoes.po}
                      onChange={onInputChange}
                      error={error_po}
                      helperText={error_po ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="ko"
                      value={operacoes?.ko === undefined ? "" : operacoes.ko}
                      onChange={onInputChange}
                      error={error_ko}
                      helperText={error_ko ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="mgo"
                      value={operacoes?.mgo === undefined ? "" : operacoes.mgo}
                      onChange={onInputChange}
                      error={error_mgo}
                      helperText={error_mgo ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="cao"
                      value={operacoes?.cao === undefined ? "" : operacoes.cao}
                      onChange={onInputChange}
                      error={error_cao}
                      helperText={error_cao ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="so"
                      value={operacoes?.so === undefined ? "" : operacoes.so}
                      onChange={onInputChange}
                      error={error_so}
                      helperText={error_so ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="b"
                      value={operacoes?.b === undefined ? "" : operacoes.b}
                      onChange={onInputChange}
                      error={error_b}
                      helperText={error_b ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      multiline
                      name="opcao"
                      value={operacoes?.opcao === undefined ? "" : operacoes.opcao}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center">
                      <ButtonCadernos
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            setShowNewRow(false)
                          }
                        }}
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleSave()}
                      />
                    </Stack>
                  </StyledTableCell>
                </TableRow>
              )}

              {(rowsPerPage > 0
                ? rows_filtrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rows_filtrada
              ).map((row, key) => (
                <TableRow key={key}>
                  {operacoes?.id_regis_ope_cult === row.id_regis_ope_cult ? (
                    <>
                      <StyledTableCell>
                        {especie_ou_lote_homegenio_lista !== undefined ? (
                          <Select
                            value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                            label={''}
                            name={'zona_homogenea'}
                            // defaultValue={especie_ou_lote_homegenio_selecionada?.id_cara === undefined ? 0 : especie_ou_lote_homegenio_selecionada?.id_cara}
                            sx={{
                              fontSize: 14,
                              fontFamily: "verdana",
                              minWidth: 200,
                            }}
                            onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                          >

                            {especie_ou_lote_homegenio_lista.map((item: IZonaHomogenea, key) => {

                              return (
                                <MenuItem key={key} value={item.zona_homogenea}>
                                  <Typography
                                    style={{
                                      fontSize: 14,
                                      fontFamily: "candara",
                                    }}
                                  >
                                    {item.zona_homogenea}
                                  </Typography>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        ) : (
                          <></>
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        {especie_ou_lote_homegenio_selecionada?.area !== undefined ? formatarNumero_recebido_com_casa_decimais(especie_ou_lote_homegenio_selecionada?.area) : '0,00'}
                      </StyledTableCell>
                      <StyledTableCell>
                        <TextField
                          name="data"
                          variant="filled"
                          type="date"
                          value={operacoes?.data}
                          onChange={onInputChange}
                        />
                        {error_data && (
                          <p style={{ color: "#c90606", fontSize: "11px" }}>
                            Preencha este campo
                          </p>
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="especis_exis"
                          value={operacoes?.especis_exis}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomSelect
                          value={operacoes?.oper_cultural !== undefined ? operacoes?.oper_cultural : ""}
                          name="oper_cultural"
                          onChange={onInputChange}
                          options={operacaocultural}
                          label="Fertilização"
                          minWidth={120}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomSelect
                          value={operacoes?.tipo_ferti !== undefined ? operacoes?.tipo_ferti : ""}
                          name="tipo_ferti"
                          onChange={onInputChange}
                          options={tipoFertilizacao}
                          label="Fertilização"
                          minWidth={120}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="ferti_utilizado"
                          value={operacoes?.ferti_utilizado}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="t"
                          value={operacoes?.t}
                          onChange={onInputChange}
                          error={error_t}
                          helperText={error_t ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="m"
                          value={operacoes?.m}
                          onChange={onInputChange}
                          error={error_m}
                          helperText={error_m ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="n"
                          value={operacoes?.n}
                          onChange={onInputChange}
                          error={error_n}
                          helperText={error_n ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="po"
                          value={operacoes?.po}
                          onChange={onInputChange}
                          error={error_po}
                          helperText={error_po ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="ko"
                          value={operacoes?.ko}
                          onChange={onInputChange}
                          error={error_ko}
                          helperText={error_ko ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="mgo"
                          value={operacoes?.mgo}
                          onChange={onInputChange}
                          error={error_mgo}
                          helperText={error_mgo ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="cao"
                          value={operacoes?.cao}
                          onChange={onInputChange}
                          error={error_cao}
                          helperText={error_cao ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="so"
                          value={operacoes?.so}
                          onChange={onInputChange}
                          error={error_so}
                          helperText={error_so ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="b"
                          value={operacoes?.b}
                          onChange={onInputChange}
                          error={error_b}
                          helperText={error_b ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="opcao"
                          value={operacoes?.opcao}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                    </>
                  ) : (
                    <>
                      <StyledTableCell>{row.zona_homo}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.area)} </StyledTableCell>
                      <StyledTableCell>{row.data} </StyledTableCell>
                      <StyledTableCell>{row.especis_exis}</StyledTableCell>
                      <StyledTableCell>{row.oper_cultural}</StyledTableCell>
                      <StyledTableCell>{row.tipo_ferti}</StyledTableCell>
                      <StyledTableCell>{row.ferti_utilizado}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.t)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.m)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.n)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.po)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.ko)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.mgo)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cao)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.so)} </StyledTableCell>
                      <StyledTableCell aria-multiline>{formatarNumero_recebido_com_casa_decimais(row.b)}</StyledTableCell>
                      <StyledTableCell>{row.opcao}</StyledTableCell>
                    </>
                  )}
                  {operacoes?.id_regis_ope_cult === row.id_regis_ope_cult ? (
                    <StyledTableCell>
                      <ButtonCadernos
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleUpdate()}
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            setOperacoes(undefined)
                          }
                        }}
                      />
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell>
                      {is_historico === true ? <></> :

                        <ButtonCadernos
                          mostrarBotaoEditar
                          aoClicarEditar={() => {
                            setShowNewRow(false);
                            handleEdit(row)
                          }}
                          mostrarBotaoApagar
                          aoClicarApagar={() => handleClickOpenDelete(row)}
                        />}
                    </StyledTableCell>
                  )}
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={19} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow sx={{ width: "100%" }}>
                <TableCell colSpan={5}>
                  <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                    * Campos de preenchimento obrigatório
                  </Typography>
                </TableCell>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={13}
                  count={rows_filtrada.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                  }}
                  labelRowsPerPage={'Linhas por página'}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
            <ConfirmDialog
              open={openDelete}
              onClose={() => setOpenDelete(false)}
              onConfirm={handleDelete}
              message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
              open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
              onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
              onConfirm={() => handleCloseDialog()}
              message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
          </table>
        </TableContainer>
      }
    </CustomThemeProvider>
  );
};
